"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NoOp = void 0;
const expression_precedence_1 = require("../expression-precedence");
const expression_node_1 = require("../nodes/expression-node");
const types_1 = require("../types");
/**
 * The `NoOp` node does not contain any logic at all, and is largely meant to be used as a placeholder (sort of like a "null" node).
 */
class NoOp extends expression_node_1.ExpressionNode {
    constructor() {
        super(...arguments);
        this[Symbol.toStringTag] = 'NoOp';
        this.children = [];
        this.precedence = expression_precedence_1.ExpressionPrecedence.Expression;
        this.type = types_1.ExpressionType.Boolean;
    }
    evaluate() {
        return true;
    }
    format() {
        return '';
    }
    clone() {
        return new NoOp();
    }
    accept(visitor) {
        visitor.visitNoOp(this);
    }
}
exports.NoOp = NoOp;
//# sourceMappingURL=no-op.js.map